import { usePassport } from '../../../hooks/usePassport';

const TeacherCodeModal = ({ onClose }) => {
	const { passport } = usePassport();

	return (
		<div className="fixed inset-0 bg-black/70 z-[1000] flex items-center justify-center p-5 backdrop-blur-sm">
			<div className="bg-white rounded-[20px] p-10 max-w-[500px] w-full shadow-[0_20px_60px_rgba(0,0,0,0.3)]">
				<h3 className="text-2xl font-bold mb-4 text-center">선생님 인증</h3>
				<p className="text-center mb-6 text-gray-600" id="pinMessage">
					스탬프 인증을 위한 PIN을 입력하세요
				</p>
				<input 
					type="password" 
					id="pinInput" 
					maxLength="4" 
					className="w-full px-4 py-3 text-center text-2xl font-bold border-2 border-blue-300 rounded-xl mb-4 focus:outline-none focus:border-blue-500 transition-colors" 
					placeholder="• • • •"
				/>
				<div className="flex gap-4">
					<button 
						onClick={onClose}
						className="flex-1 bg-gray-200 px-6 py-3 rounded-xl font-bold hover:bg-gray-300 transition-colors"
					>
						취소
					</button>
					<button 
						className="flex-1 bg-blue-600 text-white px-6 py-3 rounded-xl font-bold hover:bg-blue-700 transition-colors"
					>
						확인
					</button>
				</div>
				<p className="text-xs text-center mt-4 text-gray-500">초기 비밀번호는 보호자 휴대전화번호 뒷자리 4자리입니다.</p>
			</div>
		</div>
	);
}

export default TeacherCodeModal;